import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-view-examsheet',
  templateUrl: './view-examsheet.component.html',
  styleUrls: ['./view-examsheet.component.scss']
})
export class ViewExamsheetComponent {

public imageURL=GlobalService.imageURL;
public examData:any;
public displayedColumns: string[] = ['title', 'attend_time', 'status', 'exam_sheet', 'sign'];
public dataSource = new MatTableDataSource();
constructor(private spinner:NgxSpinnerService,private userService:UserManagementService, private dialog:MatDialog,private appService:AppService,
  public dialogRef: MatDialogRef<ViewExamsheetComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any,private commonService:CommonService){}
ngOnInit(): void {
  //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
  //Add 'implements OnInit' to the class.
   this.showExamsheet(this.dialogData.data)
}
showExamsheet  (courseData) {
  // this.modalService.open(content, { centered: true, windowClass: 'show-contract-modal' });
  let data = {
      a_ci: courseData.a_ci,
      t:courseData.t,
      c_i:courseData.c_i
  }
  this.spinner.show()
  this.userService.viewExamSheet(data).subscribe({
    next:(success:any) => {
      this.spinner.hide();
      if (success.status == 200) {
          this.examData=success.data[0]
          this.dataSource = new MatTableDataSource(success.data);
      }},
      error:(error:any)=>{
        this.commonService.handleError(error)
      }  
    });
}
onCancel(){
  this.dialogRef.close()
}
onDownload(fileUrl){
  this.appService.downloadFile(fileUrl,'examsheet')
}
}
